export class Utilities {
  formatAsMoney(value: number): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    let formattedValue = formatter.format(value < 0 ? value * -1 : value).replace(/\D00$/, '');
    return value < 0 ? `(${formattedValue})` : formattedValue;
  }

  getToken(value: string, index: number) {
    if (value && value.includes(" ")) {
      return value.split(" ")[index];
    }
    return value;
  }
}
